import { render } from "./ResaleAccounts.vue?vue&type=template&id=c76528de&scoped=true"
import script from "./ResaleAccounts.vue?vue&type=script&lang=js"
export * from "./ResaleAccounts.vue?vue&type=script&lang=js"

import "./ResaleAccounts.vue?vue&type=style&index=0&id=c76528de&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c76528de"]])

export default __exports__